import type { ClientInquiryReplyAttachment } from '@maru44/huntre-utils/src/models/clientInquiry'
import { Box, Dialog, Link, Stack } from '@mui/material'
import { useEffect, useState } from 'react'
import { IoDocumentAttachOutline } from 'react-icons/io5'
import { useStorage } from 'src/hooks/storage/useStorage'

type Props = {
  attachments?: ClientInquiryReplyAttachment[]
}

export const Attachments = ({ attachments }: Props) => {
  if (!attachments?.length) return null

  return (
    <Stack
      spacing={1}
      sx={{
        mt: 1,
      }}
    >
      {attachments.map((attachment) => (
        <AttachmentItem key={attachment.path} attachment={attachment} />
      ))}
    </Stack>
  )
}

type ItemProps = {
  attachment: ClientInquiryReplyAttachment
}

const AttachmentItem = ({ attachment }: ItemProps) => {
  const { getFileBlobUrl } = useStorage()
  const [url, setUrl] = useState('')
  const [open, setOpen] = useState(false)

  useEffect(() => {
    let active = true
    let objectUrl = ''
    // SPA遷移直後は App Check トークン等の準備が間に合わず getBlob が一時失敗することがあるためリトライする
    const load = async () => {
      for (let attempt = 0; active && attempt < 4; attempt++) {
        try {
          const u = await getFileBlobUrl(attachment.path)
          if (!active) {
            URL.revokeObjectURL(u)
            return
          }
          objectUrl = u
          setUrl(u)
          return
        } catch (e) {
          console.error(e)
          await new Promise((resolve) => setTimeout(resolve, 500 * (attempt + 1)))
        }
      }
    }
    load()
    return () => {
      active = false
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [attachment.path, getFileBlobUrl])

  if (!url) return null

  const isImage = attachment.contentType.startsWith('image/')

  if (isImage) {
    return (
      <>
        <Box
          component="img"
          src={url}
          alt={attachment.name}
          onClick={() => setOpen(true)}
          sx={{ maxWidth: '100%', maxHeight: 240, borderRadius: 1, display: 'block', cursor: 'pointer' }}
        />
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
          <Box component="img" src={url} alt={attachment.name} sx={{ maxWidth: '90vw', maxHeight: '90vh', display: 'block' }} />
        </Dialog>
      </>
    )
  }

  return (
    <Link
      href={url}
      target="_blank"
      rel="noopener"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <IoDocumentAttachOutline />
      {attachment.name}
    </Link>
  )
}
